export enum ItemCategory {
    FOOD = "FOOD",
    COLDDRINKS = "COLDDRINKS",
    HOTDRINKS = "HOTDRINKS",
    SNACKS = "SNACKS",
    VOUCHERS = "VOUCHERS",
    MISC = "MISC"
}

export class TransactionItem {
    constructor(public id: string = "", public category: ItemCategory = ItemCategory.MISC,
                public name: string = "Neuer Artikel",
                public effectivePrice: number = 0, public vatRate: number = 0) {}
}
